import axios from 'axios';

const instance = axios.create({
    baseURL: window.location.protocol + '//' + window.location.hostname + '/api'
  });
export default instance;